import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { filter, includes, keyBy, find } from 'lodash';
import { branch } from 'baobab-react/higher-order';
import Header from '../../../common/Header';
// import NavBar from '../NavBar';
import Video from '../Video';
import SupportNav from '../../SupportNav';
import videoData from './emailVideoData.json';
import Breadcrumb from '../../../common/Breadcrumb';
import BreadcrumbItem from '../../../common/BreadcrumbItem';
import Link from "../../../common/TrackedLink";
import ButtonLink from "../../../common/TrackedButtonLink";

class Videos extends Component {
	constructor(props) {
		super(props);
		this.sent=false;
		this.state = {
			search: '',
			mktgId: '',
			dfltMktgId: 'default',
			display: '',
			header: '',
			subheader: '',
			videoUrl: ''
		};
	}

	componentDidMount() {
		const { id } = this.props.params.id;
		this.setState({ mktgId: this.props.params.id });
		const script = document.createElement("script");
		script.src = "//players.brightcove.net/1213897989/lgeOB3RfT_default/index.min.js";
		script.async = true;
		document.body.appendChild(script);
	}

	filterVideos() {
		const videos = videoData;
		let locationFiltered = videos;
		if (this.props.params.id) {

			locationFiltered = filter(videos, video => {
				return includes(video.id.toLowerCase(),this.state.mktgId.toLowerCase());
			});

			if(locationFiltered.length == 0) {
				locationFiltered = filter(videos, video => {
					return includes(video.id.toLowerCase(),this.state.dfltMktgId.toLowerCase());
				});
			}
		} else {

			locationFiltered = filter(videos, video => {
				return includes(video.id.toLowerCase(),this.state.dfltMktgId.toLowerCase());
			});
		}

		this.state.display = locationFiltered[0];
		this.state.videoUrl = "https://players.brightcove.net/1213897989/default_default/index.html?videoId="+this.state.display.videoId;
		return locationFiltered;

	}

	render() {
		const { title } = this.state.header;
		const videos = this.filterVideos().map((video, index) => (
			<Video
				video={ video }
				key={ index }
			/>
		));
		
		return (
			<div className="video-library">
				<Helmet>
					<title>Video Library &#124; SentrySafe</title>
					<meta name="description" content="Use these videos to guide you through your safe setup, troubleshooting, and other support needs. View videos." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Support" path="/support" />
					<BreadcrumbItem label="Videos" path="/support/videos"/>
					<BreadcrumbItem label={ this.state.display.title } />
				</Breadcrumb>

				<SupportNav />

				<Header
					title={ this.state.display.header }
					description={ this.state.display.subheader }
				/>

				<section className="section section-videos pt-lg-5 pt-5">
					<div className="section-content-email">
						<div className="brightcove">
							<video-js
								data-account="1213897989"
								data-player="lgeOB3RfT"
								data-embed="default"
								data-video-id={this.state.display.videoId}
								controls=""
								data-application-id=""
								className="vjs-fluid">
							</video-js>

							{/*style="padding-top: 56.25%;"*/}
						</div>
					</div>
				</section>

				<section className="text-center pb-5 pb-lg-5 pt-5 pt-lg-5" id="">
					<div className="row fire">
						<div className="col sm-12">
							<h2 className="h3 font-weight-bold">More Videos</h2>
							<p className="descr">Guides to safe setup, troubleshooting, and other support needs.</p>
							<ButtonLink className="btn-primary" to="/support/videos">
								View All Videos
							</ButtonLink>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default branch({
	product: ['product']
}, Videos);


// WEBPACK FOOTER //
// ./src/pages/support/videos/email/Index.js